import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Nav from "./Nav";

const Header = () => {
  return (
    <MainHeader>
      <NavLink to="/" >
        <img src="./images/logo1.jpg" alt="my logo img" className="logo-header"/>
      </NavLink>
      <Nav />
    </MainHeader>
  );
};

const MainHeader = styled.header`
padding : 0 4.8rem;
// margin-top: 1rem;
display: flex;
justify-content: space-between;
align-items: center;
position: relative;
height: 10rem;
background-color:${({ theme }) => theme.colors.bg};
}
.logo{
    height:5rem;
}
`;

export default Header;
